import tinymce from 'tinymce/tinymce';

import 'tinymce/themes/modern';

import 'tinymce/plugins/hr';
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/image'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/media'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/save'
import 'tinymce/plugins/table'
import 'tinymce/plugins/template'
import 'tinymce/plugins/textcolor'

// require.context('file-loader?name=[path][name].[ext]&context=node_modules/tinymce!tinymce/skins', true, /.*/);

// import "tinymce/skins/lightgray/skin.min.css";
// import "tinymce/skins/lightgray/content.min.css";


var file_browser_callback = function (input_id, input_value, type, win) {
    var cmsURL = '/admin/filebrowser/browse/?pop=2';
    cmsURL = cmsURL + '&type=' + type;

    tinymce.activeEditor.windowManager.open({
        file: cmsURL,
        width: 980,  // Your dimensions may differ - toy around with them!
        height: 500,
        resizable: 'yes',
        scrollbars: 'yes',
        inline: 'no',  // This parameter only has an effect if you use the inlinepopups plugin!
        close_previous: 'no'
    }, {
        window: win,
        input: input_id
    });
    return false;
};

// tinyMCE.baseURL = '/static/bower_components/tinymce';

var tinyMCE_base_settings = {
    menubar: false,
    width: '100%',
    height: '500px',
    indentation: '10px',
    relative_urls: false,
    body_class: 'tinymce_publications',
    browsers: 'gecko,msie,safari,opera',
    dialog_type: 'window',
    keep_styles: false,
    language: 'en',
    object_resizing: false,
    fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
    media_strict: true,

    //selector: 'textarea:not(.mceNoEditor)',
    plugins: [
        "hr link image charmap paste print preview anchor pagebreak searchreplace visualblocks visualchars code fullscreen",
        "insertdatetime media nonbreaking save table template textcolor",
    ],
    toolbar1: "undo removeformat blockquote redo subscript superscript | cut copy paste | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify",
    toolbar2: "bullist numlist outdent indent | link anchor image media | forecolor backcolor | fontsizeselect | formatselect | table | nonbreaking | code",

    image_advtab: true,
    skin: 'lightgray',
    skin_url: '/static/tinymce/skins/lightgray',

    image_class_list: [
        {title: '', value: ''},
        {title: 'Image Left', value: 'img_left'},
        {title: 'Image Right', value: 'img_right'},
        {title: 'Image Block', value: 'img_block'},
        {title: 'Image Left No Frame', value: 'img_left_no_frame'},
        {title: 'Image Right No Frame', value: 'img_right_no_frame'},
        {title: 'Image Block No Frame', value: 'img_block_no_frame'}

    ],

    content_css: "/static/tinymce/custom_content.css",

    style_formats: [

        {title: '12px', inline: 'span', styles: {'font-size':'12pt','font-weight':'bold'}},

        {title: '24px', inline: 'span', styles: {'font-size': '24pt',color: 'red'}},

        {title: '36px', inline: 'span', styles: {'font-size': '36pt'}}

    ],

    file_browser_callback: file_browser_callback,

//    formats: {
//      removeformat: [
//        {selector: 'b,strong,em,i,font,u,strike', remove : 'all', split : true, expand : false, block_expand: true, deep : true},
//        {selector: 'span', attributes : ['style', 'class'], remove : 'empty', split : true, expand : false, deep : true},
//        {selector: '*', attributes : ['style', 'class'], split : false, expand : false, deep : true}
//      ]
//    }
};

tinyMCE_base_settings['video_template_callback'] = function(data) {
    return '<video width="' + data.width + '" height="' + 'auto' + '"' +
        '' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' +
        '' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' +
            '' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' +
            '' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
};

window.tinyMCE_base_settings = tinyMCE_base_settings;